import { matchPath } from 'react-router-dom'
import Utils from '../../../../common/Utils'

export const REGISTER_ROUTES = {
  base: '/:lang/asian/register',
  verify: '/:lang/asian/register/verify',
  verifiedSuccessfully: '/:lang/asian/register/verified-successfully',
}

export const REGISTER_STEPS = {
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  DEPOSIT: 'DEPOSIT',
}

export const KYC_VERIFIED = {
  CUSTOMER_VERIFIED: 'CUSTOMER_VERIFIED',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  LEGACY_USER: 'LEGACY_USER',
  UNVERIFIED: "UNVERIFIED"
}

export const changeRouteRegister = (route, iframeLang) =>
  route.replace(':lang', iframeLang ? iframeLang : Utils.getCurrentLang())

export const getRouteFromPostMessage = (currentStep, pathname, isUpdatedLang) => {
  if ((
    currentStep === REGISTER_STEPS.CREATE_ACCOUNT &&
    matchPath(pathname, {
      path: REGISTER_ROUTES.base,
      exact: true
    }) === null) || isUpdatedLang
  ) {
    return REGISTER_ROUTES.base
  }

  if (
    (currentStep === REGISTER_STEPS.VERIFY_EMAIL &&
      matchPath(pathname, {
        path: REGISTER_ROUTES.verify,
        exact: true
      }) === null)
    || isUpdatedLang
  ) {
    return REGISTER_ROUTES.verify
  }

  if (
    (currentStep === REGISTER_STEPS.DEPOSIT &&
      matchPath(pathname, {
        path: REGISTER_ROUTES.verifiedSuccessfully,
        exact: true
      }) === null)
    || isUpdatedLang
  ) {
    return REGISTER_ROUTES.verifiedSuccessfully
  }
  return null
}



// WEBPACK FOOTER //
// ./src/app/components/MainComponent/AsiaView/MbAsiaVIPSignup/utils.js